import request from '@/utils/request'

/*
 *@描述: 获取协议内容
 *@参数: data:{
   pageType: 协议
 }
 *@作者: 金涛
 *@日期: 2021-10-25 10:49:14
 */
export function getContent({ pageType, source }) {
  return request({
    url: `/content/get`,
    method: 'POST',
    headers: {
      loading: false,
    },
    data: {
      pageType,
      source,
    },
  })
}

/*
 *@描述: 获取所有地区
 *@参数:  无
 *@作者: 金涛
 *@日期: 2021-10-25 15:24:32
 */
export function getRegions(id) {
  return request({
    url: `/regions/${id}/children`,
    method: 'GET',
    headers: {
      loading: false,
    },
  })
}

/*
 *@描述: 获取跳转商店的下载链接
 *@参数: channel: 渠道标识
        是否需要token
 *@作者: 金涛
 *@日期: 2021-10-26 15:38:54
 */
export function getDownloadUrl(channel, needToken = false, loading = false) {
  return request({
    url: channel ? `/channel/download?channel=${channel}` : `/channel/download`,
    method: 'GET',
    headers: {
      channel,
      needToken,
      loading,
    },
  })
}

/*
 *@描述: 获取跳转产品列表页面的产品列表数据
 *@参数: data {
    pageNum: 1,
    pageSize: 5,
 }
 *@作者: 金涛
 *@日期: 2022-04-26 20:26:54
 */
export function queryProductList(data) {
  return request({
    url: '/product/api/h5CpaProductPageList',
    method: 'POST',
    headers: {
      needToken: true,
    },
    data,
  })
}

/*
 *@描述: 闪借花的产品推荐页面列表点击进行埋点(需要登录)
 *@参数: data {
   productId: 产品ID,
   showPage: 页面点击区域类型
 }
 *@作者: 金涛
 *@日期: 2022-06-08 19:23:40
 */
function checkThenAddLoanRecord(data, needToken) {
  return productCheckRequest({ productId: data.productId }, needToken).then((checkRes) => {
    const checkData = checkRes && checkRes.code === 200 ? checkRes.data : null
    if (!checkData || !checkData.linkUrl) {
      const error = new Error((checkRes && checkRes.msg) || '获取跳转链接失败')
      error.response = checkRes
      return Promise.reject(error)
    }

    const productId = checkData.productId || data.productId
    return addLoanRecordRequest({ ...data, productId }, needToken)
      .catch((error) => {
        console.error('addLoanRecord 失败', error)
        return null
      })
      .then((loanRecordRes) => ({
        ...checkRes,
        data: { ...checkData, productId },
        loanRecordRes,
      }))
  })
}

// 前置协议需要在弹窗流程结束后才记录点击，因此允许页面单独延后调用记录接口。
export function addLoanRecordRequest(data, needToken = true) {
  return request({
    url: '/product/api/addLoanRecord',
    method: 'POST',
    headers: {
      needToken,
    },
    data,
  })
}

export function buried(data) {
  return checkThenAddLoanRecord(data, true)
}

/*
 *@描述: 闪借花的产品推荐页面列表点击进行埋点(不需要登录)
 *@参数: data {
   productId: 产品ID,
   showPage: 页面点击区域类型
   busType:3 (2-默认传值 3-未登录CPA列表h5页)
 }
 *@作者: 金涛
 *@日期: 2022-10-16 17:23:40
 */
export function notLoginBuried(data) {
  return checkThenAddLoanRecord(data, false)
}

/*
 *@描述: 进件信息的页面，保存进件信息(原异步进件接口/rsa/user/h5/apply)
 更换为(同步接口/rsa/loan/h5ApplyV2)
 逻辑更改为
 1）用户完成进件判断当前用户是否可以被推送
 2）可以被推送：进入引导接听电话页面（按照模版配置的引导接听电话页面显示）
    不能被推送：跳转app下载页面（固定使用调起APP时的下载页模版）
 *@参数: data: {
    channelNo: // 渠道标识
    realName: "", // 姓名
    idCard: "", // 身份证号码
    credit: "", // 芝麻分
    jdIous: "", // 京东分
    assets: "", // 个人资产
    gpsCityName: "", // 省市展示名称
    cityId: "", // 城市ID
    provinceId: "", // 省ID
 }
 *@作者: 金涛
 *@日期: 2022-08-11 11:36:08
 */
export function submitAnEntry(data) {
  return request({
    url: '/rsa/loan/h5ApplyV2',
    method: 'POST',
    timeout: 60000,
    headers: {
      needToken: true,
    },
    data,
  })
}

export function submitPushApply2JQB(data) {
  return request({
    url: '/loan/pushApply2JQB',
    method: 'POST',
    timeout: 60000,
    headers: {
      needToken: true,
    },
    data,
  })
}
/*
 *@描述: 获取闪借花三方签约跳转回调页面H5 获取订单信息
 *@参数: {
  orderNo: 订单编号
  opt: loan=放款、repay=还款
 }
 *@作者: 金涛
 *@日期: 2022-08-09 15:06:23
 */
export function queryOrderInfo(orderNo, opt) {
  return request({
    url: `/loan/getReturnByOrderSn/${orderNo}/${opt}`,
    method: 'GET',
    headers: {
      needToken: true,
    },
  })
}

/*
 *@描述: 进件流程结果页更换，需要查询进件成功的机构名称以及机构logo
 *@参数: applyId: 进件申请ID
 *@作者: 金涛
 *@日期: 2022-10-23 18:40:45
 */
export function getMechanismInfo(object) {
  return request({
    url: `/loan/h5ApplyAuditResult/${object.applyId}/${object.apiReqType}`,
    method: 'GET',
    headers: {
      needToken: true,
    },
  })
}
/*
 *@描述: 进件流程结果页更换，需要查询进件成功的机构名称以及机构logo
 *@参数: applyId: 进件申请ID
 *@作者: pl
 *@日期: 2026-01-10
 */
export function getInterfaceMechanismInfo(object) {
  return request({
    url: `/loan/interfaceApplyAuditResult/${object.applyId}/${object.apiReqType}`,
    method: 'GET',
    headers: {
      needToken: true,
    },
  })
}

/*
 *@描述: 获取进件结果页面的单个产品详情信息
 *@参数: showPage: 15,H5进件完成页(用于页面底部的产品详情查询),16,投放页完成下载APP(用于页面弹窗的产品详情查询),
 *@作者: 金涛
 *@日期: 2022-10-25 20:49:37
 */
export function getProductInfo(data) {
  return request({
    url: '/product/api/recommend/single',
    method: 'post',
    headers: {
      needToken: true,
    },
    data,
  })
}
/*
 *@描述: 获取进件结果页面的单个产品详情信息,recommend/single 已弃用
 *@参数: showPage: 15,H5进件完成页(用于页面底部的产品详情查询),16,投放页完成下载APP(用于页面弹窗的产品详情查询),
 *@作者: zn
 *@日期: 2025-10-14 15:49:37
 */
export function h5CpaProductRecommendRequest(data) {
  return request({
    url: '/product/api/h5CpaProductRecommend',
    method: 'post',
    headers: {
      needToken: true,
    },
    data,
  })
}

/*
 *@描述: 获取H5还款计划列表
 *@参数: applyId: 还款计划ID
 *@作者: 金涛
 *@日期: 2022-10-27 15:36:45
 */
export function getApplyData(applyId) {
  return request({
    url: `/loan/repayPlanItems/${applyId}`,
    method: 'GET',
    headers: {
      needToken: true,
      loading: false,
      device: 'APP',
    },
  })
}

/**
 * 推送进见申请
 * @param {*} data
 * @returns
 */
export function pushApply(data) {
  return request({
    url: '/loan/pushApply',
    method: 'post',
    timeout: 180000,
    headers: {
      needToken: true,
    },
    data,
  })
}

// applySource
export function addMatchStayLog(data) {
  return request({
    url: '/loan/addMatchStayLog',
    method: 'post',
    headers: {
      needToken: true,
      loading: false,
    },
    data,
  })
}

// 进件页面条状第三方跳转记录结构
export function statisticCallBackUrlData(data) {
  return request({
    url: '/loan/statisticCallBackUrlData',
    method: 'post',
    headers: {
      needToken: true,
      loading: false,
    },
    data,
  })
}

// 查询用户详细信息
export function getUserDetail() {
  return request({
    url: '/user/getUserDetail',
    method: 'GET',
    headers: {
      needToken: true,
      loading: false,
    },
  })
}

/** 用户详情；响应 data 中含 showCarInfo（是否允许与「有车」联动展示车辆信息等） */
export function getUserDetailOld(channelCode) {
  const config = {
    url: '/user/queryUserDetailOld',
    method: 'GET',
    headers: {
      needToken: true,
      loading: false,
    },
  }
  if (channelCode != null && channelCode !== '') {
    config.params = { channelCode }
  }
  return request(config)
}
export function getCityLocation() {
  return request({
    url: '/regions/getCityLocation',
    method: 'GET',
    headers: {
      needToken: false,
      loading: false,
    },
  })
}

function MixinClientBrowser() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //ios
    return 'ios'
  } else if (/(Android)/i.test(navigator.userAgent)) {
    //android
    return 'android'
  }
}

// 获取链接上参数
function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// 埋点文案映射：仅 Vue 工程（src 下通过本文件 handleBatchTrackBase 上报）。
// public 下静态 HTML 页的映射见 public/js/base.js 中 TRACK_MAP。
const TRACK_MAP = {
  // 独立下载入口沿用原 public/download/index.html 的点位语义。
  'default:100001': {
    page: '浏览，进入页面',
    remark: '浏览PV',
    pageTitle: 'API半流程-API半流程下载页',
  },
  'default:100002': {
    page: '点击【下载闪借花APP】按钮',
    remark: '点击数',
    pageTitle: 'API半流程-API半流程下载页',
  },
  'default:100075': { page: '进入榕树下载页面', pageTitle: '榕树下载页面' },
  'default:100098': {
    page: '下载页面跳转下游 H5',
    pageTitle: 'API半流程-API半流程下载页',
  },
  // API半流程-城市拦截下载页（与 public/js/base.js 100001/100002 文案一致，Vue SPA 半流程页复用）
  'default:100086': {
    page: '浏览，进入页面',
    remark: '浏览PV',
    pageTitle: '渠道半流程其他下载页',
  },
  'default:100087': {
    page: '点击【下载闪借花APP】按钮',
    remark: '点击数',
    pageTitle: '渠道半流程其他下载页',
  },
  'default:100088': {
    page: '浏览，进入页面',
    remark: '浏览PV',
    pageTitle: '进件之后的是渠道半流程进件下载页',
  },
  'default:100089': {
    page: '点击【下载闪借花APP】按钮',
    remark: '点击数',
    pageTitle: '进件之后的是渠道半流程进件下载页',
  },

  'default:100012': {
    page: '浏览，进入页面',
    remark: '浏览PV',
    pageTitle: 'API半流程-loading页面',
  },

  // entryIdentity 开始
  'default:100014': { page: '浏览，进入页面', remark: '浏览PV' },
  'default:100015': { page: '点击【领取额度】按钮', remark: '点击数' },
  'default:100016': { page: '勾选协议', remark: '点击数' },

  'default:100017': { page: '协议确认弹窗', remark: '浏览PV', pageTitle: '通用一协议确认弹窗' },
  'default:100018': {
    page: '点击【我已知晓】，跳转到进件结果页面',
    remark: '点击数',
    pageTitle: '通用一协议确认弹窗',
  },
  'default:100019': {
    page: '点击【我已知晓】，跳转到贷超页面',
    remark: '点击数',
    pageTitle: '通用一协议确认弹窗',
  },
  'default:100020': {
    page: '点击【我已知晓】，跳转到APP下载页',
    remark: '点击数',
    pageTitle: '通用一协议确认弹窗',
  },
  // entryIdentity 结束

  //  formPageBuriedMixin 开始
  'default:100030': { page: '浏览，进入表单页面', remark: '浏览PV' },
  'default:100031': { page: '勾选协议', remark: '点击数' },
  'default:100032': { page: '表单页面，用户点击【确认额度】，未勾选协议', remark: '点击数' },
  'default:100033': { page: '表单页面，用户点击【确认额度】，弹窗协议', remark: '点击数' },
  'default:100034': {
    page: '撞库协议确认弹窗',
    remark: '浏览PV',
    pageTitle: 'H5新页面一-撞库协议确认弹窗',
  },
  'default:100035': {
    page: '用户点击【我已知晓】',
    remark: '点击数',
    pageTitle: 'H5新页面一-撞库协议确认弹窗',
  },
  // registerEntryTl5ThemeOne formPageBuriedMixin 结束

  // resultSuccessBuriedMixin 开始
  'default:100036': { page: '进入产品结果页面', remark: '浏览PV' },
  'default:100037': { page: '用户点击【确认额度】（跳转贷超）', remark: '点击数' },
  'default:100038': { page: '用户点击【确认额度】（触发APP下载）', remark: '点击数' },
  'default:100039': { page: '用户点击【立即申请】（外跳）', remark: '点击数' },
  'default:100040': { page: '用户点击【立即申请】（内跳）', remark: '点击数' },
  // resultSuccessBuriedMixin 结束

  'default:100052': { page: '浏览，进入撞库进件失败下载页面', remark: '浏览PV' },
  'default:100053': { page: '点击「下载APP，匹配更多资金」按钮', remark: '点击数' },
  'default:100056': { page: '浏览，进入撞库拦截失败下载页面', remark: '浏览PV' },
  'default:100057': { page: '点击「下载APP，匹配更多资金」按钮', remark: '点击数' },

  // 产品详情页面（贷超详情）开始
  'default:20129': { page: '贷超详情页面进入-PV', remark: '浏览PV' },
  'default:20130': { page: '用户点击贷超详情页勾选协议', remark: '点击数' },
  'default:20131': {
    page: '用户点击贷超详情页《黄金会员服务协议》',
    remark: '点击数',
  },
  'default:20132': { page: '用户点击贷超详情页点击立即申请按钮', remark: '点击数' },
  // 产品详情页面（贷超详情）结束

  // 下载页开始
  'default:60201': {
    page: '下载页-下载APP完成取款(download页面)',
    remark: '下载页-下载APP完成取款(download页面)',
  },
  // 下载页结束

  // 产品弹窗开始
  'default:20701': {
    page: '产品结果页-贷超跳转规则-当前推贷超弹窗点击申请产品-跳转产品详情（内跳）',
    remark: '点击数',
  },
  'default:20702': {
    page: '产品结果页-贷超跳转规则-当前推贷超弹窗点击申请产品-跳转三方h5（外跳））',
    remark: '点击数',
  },
  // 产品弹窗结束

  'default:100058': { page: '半流程获取跳转url', remark: '浏览PV' },

  'default:100059': {
    pageTitle: '尾部贷超详情loading页面',
    page: '浏览，进入尾部贷超产品loading',
    remark: '浏览PV',
  },
  'default:100060': { page: '浏览，进入尾部贷超详情页面', remark: '浏览PV' },
  'default:100061': { page: '尾部贷超详情页面-用户点击立即申请按钮', remark: '点击数' },
  'default:100062': { page: '尾部贷超详情页面 ，点击“勾选协议”', remark: '点击数' },

  // 暂无匹配产品页面开始
  'default:100063': {
    pageTitle: '暂无匹配产品页面',
    page: '浏览，进入暂无匹配产品页面',
    remark: '浏览PV',
  },
  // 暂无匹配产品页面结束

  'default:100064': {
    pageTitle: '撞库成功协议页面',
    page: '点击“同意协议，立即申请”按钮',
    remark: '点击数',
  },
  'default:100065': {
    pageTitle: '撞库成功协议页面',
    page: '进入撞库成功协议页面',
    remark: '浏览PV',
  },
  'default:100084': {
    page: '浏览，进入闪借花plus下载页面',
    remark: '浏览PV',
    pageTitle: '闪借花plus下载页面',
  },
  'default:100085': {
    page: '点击「下载APP，匹配更多资金」按钮',
    remark: '点击数',
    pageTitle: '闪借花plus下载页面',
  },
  'default:100095': {
    page: '浏览，进入闪借花plus下载页面',
    remark: '浏览PV',
    pageTitle: '闪借花plus下载页面',
  },
  'default:100096': {
    page: '点击「下载APP，匹配更多资金」按钮',
    remark: '点击数',
    pageTitle: '闪借花plus下载页面',
  },
  'default:100099': {
    pageTitle: '撞库成功协议页面',
    page: '点击“同意协议，立即申请”按钮，跳转下游 H5',
    remark: '点击数',
  },

  // 半流程结束
  // scene overrides（Vue）
  // 场景公共配置：同一个页面通用 pageTitle 只配置一次

  // 表单页面开始
  'registerEntryTl5ThemeOne:pageTitle': { pageTitle: 'H5新页面一进件闪借花2' },
  'entryChjq:pageTitle': { pageTitle: '进件草船2' },
  'entryOrange:pageTitle': { pageTitle: '进件橙色' },
  'entryReview:pageTitle': { pageTitle: '榕树h5标准审核模版-进件' },
  'entryReviewCity:pageTitle': { pageTitle: '榕树h5标准模版-进件(城市黑白名单判断)' },
  'entrySjh:pageTitle': { pageTitle: '进件闪借花' },
  // 勾选协议模板单独命名，避免与原进件模板的埋点混用。
  'entrySjhAgree:pageTitle': { pageTitle: '进件闪借花-勾选协议' },
  'entrySjh2:pageTitle': { pageTitle: '进件闪借花2' },
  'registerEntryTl5:pageTitle': { pageTitle: '进件草船' },
  // 表单页面结束

  // 信贷留资页-城市（mapPosition mixin，原 handleBatchTrack 20205/20206）
  'default:20205': { page: '信贷留资页-选择城市', remark: '', pageTitle: '信贷留资页-城市' },
  'default:20206': { page: '信贷留资页-GPS代入城市', remark: '', pageTitle: '信贷留资页-城市' },

  'default:100066': { page: '进入京东下载页的iframe', remark: '浏览PV' },
  'default:100067': { page: '进入京东下载页', remark: '浏览PV' },

  'default:100068': { page: '进入appFrame页面', remark: '浏览PV' },
  'default:100069': { page: 'frame不兼容直接window.location.href打开三方', remark: '浏览PV' },
  'default:100070': { page: 'frame加载失败', remark: '浏览PV' },
  'default:100071': { page: 'frame加载成功，打开三方页面', remark: '浏览PV' },
  'default:100072': { page: 'frame加载成功，打开三方页面', remark: '浏览PV' },

  'default:100091': { page: 'tgFrame加载成功' },
  'default:100092': { page: 'tgFrame加载失败' },

  'default:100073': { page: '京东拦截弹窗-sjhjd渠道：返回拦截弹窗', remark: '浏览PV' },
  'default:100074': {
    page: '京东拦截弹窗-sjhjd渠道：返回拦截弹窗-用户点击京东拦截弹窗“继续填写(高额)”',
    remark: '点击数',
  },
  'default:100082': {
    page: '京东拦截弹窗-sjhjd渠道：返回拦截弹窗-用户点击关闭按钮',
    remark: '点击数',
  },
  'default:100083': { page: '表单页获取三方链接失败', remark: 'check 接口返回错误' },
  // 表单页加载耗时埋点（formPageLoadTrackMixin）
  'default:100076': { page: '浏览，表单页面加载渲染完成耗时', remark: '浏览PV' },
  'default:100077': { page: '浏览，getUserDetail返回并渲染完成耗时', remark: '浏览PV' },
  'default:100078': { page: '表单页-单步填写/选择完成', remark: '点击数' },
  'default:100079': { page: '表单页-真实姓名填写完成', remark: '点击数' },
  'default:100080': { page: '表单页-身份证填写完成', remark: '点击数' },
  'default:100081': { page: '表单页-所在城市选择完成', remark: '点击数' },

  'default:100093': { page: '小程序webview内打开页面', remark: '浏览PV' },
  // 产品结果页面 开始
  'entryIdentity:pageTitle': { pageTitle: '大联登-身份信息页' },
  'resultOrangeThemeOne:pageTitle': { pageTitle: '新H5页面-产品结果页' },
  'resultCchjq:pageTitle': { pageTitle: '草船2' },
  'resultSjh:pageTitle': { pageTitle: '闪借花' },
  'resultHalfUnion:pageTitle': { pageTitle: '产品结果页4' },
  'resultOrange:pageTitle': { pageTitle: '模板-橙色' },
  'resultSjh2:pageTitle': { pageTitle: '产品结果页6' },
  'resultUnion:pageTitle': { pageTitle: '产品结果页7' },
  'trialSuccessTl3:pageTitle': { pageTitle: '草船' },
  // 产品结果页面 结束

  'resultLoanThemeTwo:pageTitle': { pageTitle: '新H5页面-撞库进件失败下载页1' },
  'resultLoanThemeOne:pageTitle': { pageTitle: '新H5页面-撞库进件失败下载页2' },

  // 产品详情页面（贷超详情）开始
  'productDetail:pageTitle': { pageTitle: '贷超详情页' },
  // 产品详情页面结束

  // 下载页开始
  'download:pageTitle': { pageTitle: '下载页' },
  // 下载页结束

  // 产品弹窗开始
  'productsPop:pageTitle': { pageTitle: '产品弹窗' },
  // 产品弹窗结束

  'registerEntryBlc:pageTitle': { pageTitle: '半流程表单页' },
  'resultMultipleProducts:pageTitle': { pageTitle: '多推结果页' },

  // 尾部产品详情页（新）开始
  'productDetailNew:pageTitle': { pageTitle: '尾部贷超详情页面' },

  // 产品详情页（新）结束

  'downloadAppJd:pageTitle': { pageTitle: '京东下载页' },

  'appFrame:pageTitle': { pageTitle: 'appFrame页面' },
  'tgFrame:pageTitle': { pageTitle: 'tgFrame页面' },
  'resultHalfLoanLoading:pageTitle': { pageTitle: '半流程loading页面' },
  'tgFrame:pageTitle': { pageTitle: '甜瓜iframe' },
}

// 全局埋点方法（统一稳定版本） 出自 常念
export function handleBatchTrackBase(eventType, context = {}) {
  let userId = context.userId || localStorage.getItem('userId') || ''
  if (userId === 'null' || userId === 'undefined') userId = ''
  let timestamp = new Date().getTime()
  const key = String(eventType || '')
  const globalSceneKey = (typeof window !== 'undefined' && window.__TRACK_SCENE_KEY__) || ''
  const sceneKey = context.sceneKey || globalSceneKey || ''
  const defaultMapped = TRACK_MAP[`default:${key}`] || {}
  const sceneCommonMapped = sceneKey ? TRACK_MAP[`${sceneKey}:pageTitle`] || {} : {}
  const sceneMapped = sceneKey ? TRACK_MAP[`${sceneKey}:${key}`] || {} : {}
  const mapped = { ...defaultMapped, ...sceneCommonMapped, ...sceneMapped }
  const resolvedPageTitle =
    context.pageTitle ||
    defaultMapped.pageTitle ||
    sceneMapped.pageTitle ||
    sceneCommonMapped.pageTitle ||
    ''
  if (process.env.NODE_ENV !== 'production' && Object.keys(mapped).length === 0) {
    console.warn('[埋点] 未命中 TRACK_MAP 配置', {
      eventType: key,
      sceneKey,
    })
  }

  // 兼容多种浏览器判断函数
  let osType = MixinClientBrowser()

  // 获取渠道
  let source =
    context.channelCode ||
    context.source ||
    getQueryString('source') ||
    getQueryString('channel') ||
    ''
  // 获取渠道ID
  let tid =
    context.tid ||
    getQueryString('tid') ||
    getQueryString('applyPageUrlTid') ||
    getQueryString('downPageUrlTid') ||
    ''
  let productId = context.productId || getQueryString('productId') || ''
  if (productId === 'null' || productId === 'undefined') productId = ''

  let postData = {
    events: [
      {
        userId: userId,
        channelCode: source,
        osType: osType == 'ios' || osType === 1 ? 1 : 0,
        page: context.page || mapped.page || '',
        pageName: window.location.pathname,
        eventType: key,
        pointType: 0,
        plat: 0,
        eventTime: timestamp,
        eventProperties: context.eventProperties || mapped.eventProperties || window.location.href,
        remark: context.remark || mapped.remark || '',
        tid: tid,
        pageTitle: resolvedPageTitle,
        productId: productId,
      },
    ],
  }

  request({
    url: '/event/point/batchTrack',
    method: 'post',
    headers: {
      needToken: true,
      loading: false,
    },
    data: postData,
    keepalive: true,
  })
  console.log('请求了埋点:', eventType)
}

//获取产品跳转url
export function productCheckRequest(data, needToken = true) {
  return request({
    url: '/product/api/check',
    method: 'post',
    returnErrorResponse: true,
    headers: {
      needToken,
      loading: false,
    },
    data,
  })
}
// 获取产品详情接口
export function getProductDetailRequest(productId) {
  return request({
    url: `/product/api/appCpaProductDetail/${productId}`,
    method: 'GET',
    headers: {
      needToken: true,
      loading: true,
    },
  })
}

// 获取跳转所有产品
export function h5CpaProductAllPageList(data) {
  return request({
    url: '/product/api/h5CpaProductAllPageList',
    method: 'post',
    headers: {
      needToken: true,
    },
    data,
  })
}

// 获取联登跳转URL及协议信息
export function getUnionReturnUrl(data) {
  return request({
    url: '/standard/union/getReturnUrl',
    method: 'POST',
    headers: {
      needToken: false,
      loading: false,
    },
    data,
  })
}

/**
 * 渠道城市拦截接口
 * 根据请求IP判断当前城市是否在渠道允许范围内
 * @param {string} channelNo 渠道号
 * @returns {Promise} true=城市通过（走保存表单流程），false=城市被拦截（走submitAnEntry流程）
 */
export function checkChannelCity(channelNo) {
  return request({
    url: '/h5entry/checkChannelCity',
    method: 'POST',
    headers: {
      needToken: true,
      loading: false,
    },
    data: { channelNo },
  })
}

/**
 * 半流程查询处理结果（轮询接口）
 * @param {Object} data { source, processId, sign }
 * @returns {Promise} ChannelHalfProcessVO
 */
export function getHalfReturnUrl(data) {
  return request({
    url: '/standard/half/channel/getReturnUrl',
    method: 'POST',
    headers: {
      needToken: false,
      loading: false,
    },
    data,
  })
}

// 协议列表页按半流程渠道查询关联产品，协议数据由产品配置统一返回。
export function getHalfChannelProductList(channelNo) {
  return request({
    // url: '/standard/half/channel/getProductList',
    url: '/standard/half/channel/getProtocolList',
    method: 'POST',
    headers: {
      needToken: false,
      loading: false,
    },
    data: { channelNo },
  })
}

/**
 * 下载入口 applyId 前置分流。
 * @param {Object} data { applyId }
 * @returns {Promise<{code: number, data: {type: number, url: string}}>} 分流类型和参数/跳转 URL
 */
export function getDownloadApplyRoute(data) {
  return request({
    // 单独覆盖 axios 默认的 app-api 基址，确保请求进入 gather-api。
    baseURL: process.env.VUE_APP_GATHER_API,
    url: '/channel/standard/queryPageUrl',
    method: 'POST',
    headers: {
      needToken: false,
      loading: false,
    },
    data,
  })
}

export function setRecordAccess(data) {
  return request({
    url: '/standard/half/channel/recordAccess',
    method: 'POST',
    headers: {
      needToken: false,
      loading: false,
    },
    data,
  })
}

/**
 * 保存H5进件表单信息（仅保存，不推送）
 * 用于渠道城市拦截通过后保存用户填写的表单数据
 * @param {Object} data 表单数据（realName、idCard 需 RSA 加密）
 * @returns {Promise}
 */
export function saveFormInfo(data) {
  return request({
    url: '/rsa/loan/h5SaveFormInfo',
    method: 'POST',
    headers: {
      needToken: true,
    },
    data,
  })
}

/**
 * 930 新流程结果页配置；产品、展示开关和下载入口均以当前渠道回包为准。
 * @param {Object} data { channelCode: string }
 * @returns {Promise}
 */
export function resultLoanSuperList(data) {
  return request({
    url: '/product/api/resultLoanSuperList',
    method: 'POST',
    headers: {
      needToken: true,
    },
    data,
  })
}

export function newGetIsolationCity(data) {
  return request({
    url: '/standard/half/channel/getIsolationCity',
    method: 'POST',
    headers: {
      needToken: true,
    },
    data,
  })
}

export function getLogoUrl(channelCode) {
  return request({
    url: '/opening/api/queryBrandByChannel',
    method: 'POST',
    headers: {
      needToken: false,
      loading: false,
    },
    data: { channelCode },
  })
}

// 一、二次推送产品查询接口
export function secondPushProduct(channelCode, productId, applyId, isLoopProduct, isHalfProduct) {
  const data = {
    channelCode: channelCode || '',
    productId: productId || '',
    applyId: applyId || '',
    isLoopProduct: isLoopProduct,
  }
  if (isHalfProduct) {
    data.isHalfProduct = isHalfProduct
  }
  return request({
    url: '/loan/secondPushProduct',
    method: 'POST',
    headers: {
      needToken: true,
    },
    data,
  })
}

// 半流程多推：延迟进件调度（成功失败不影响主流程）
export function scheduleDelayPushApply(data) {
  return request({
    url: '/loan/pushApply/scheduleDelay',
    method: 'POST',
    headers: {
      needToken: true,
      loading: false,
    },
    data,
  })
}

// 查询当日强推进件成功产品列表
export function getSecondSuccessProduct(channelCode, applyId, secondPushProductList) {
  const list = Array.isArray(secondPushProductList)
    ? secondPushProductList.filter((x) => x != null && x !== '').map((x) => String(x))
    : secondPushProductList == null || secondPushProductList === ''
    ? []
    : [String(secondPushProductList)]
  return request({
    url: '/loan/getSecondSuccessProduct',
    method: 'POST',
    headers: {
      needToken: true,
    },
    data: { channelCode: channelCode, applyId: applyId, secondPushProductList: list },
  })
}

// 尾部cpa产品详情
export function pushCpaProductDetail(applyId) {
  // 获取 source 参数
  let source =
    (typeof window !== 'undefined' &&
      ((window.$route && window.$route.query && window.$route.query.source) ||
        (window.location && new URLSearchParams(window.location.search).get('source')))) ||
    ''
  return request({
    url: '/product/api/pushCpaProductDetail',
    method: 'POST',
    headers: {
      needToken: true,
      loading: false,
    },
    data: { applyId: applyId, showPage: 27, channelCode: source },
  })
}

// 半流程获取三方链接后，实时 check、记录点击，再将最新地址交给调用方
export function getHalfDownloadUrl(channelCode, processId, h5ChannelCode = '') {
  return request({
    url: '/standard/half/channel/getDownloadUrl',
    method: 'POST',
    headers: {
      needToken: true,
      loading: false,
    },
    data: { channelCode: channelCode, processId: processId, h5ChannelCode: h5ChannelCode },
  }).then((res) => {
    if (res && res.code === 200 && res.data && res.data.productId) {
      const { productId, showPage = 27 } = res.data
      return buried({ productId, showPage }).then((checkRes) => {
        return {
          ...res,
          data: {
            ...res.data,
            productId: checkRes.data.productId || productId,
            url: checkRes.data.linkUrl,
          },
        }
      })
    } else {
      return res
    }
  })
}

export function pageView(processId, source) {
  return request({
    url: `/standard/half/channel/pageView`,
    method: 'POST',
    headers: {
      needToken: true,
      loading: false,
    },
    data: {
      processId: processId,
      source: source,
    },
  })
}
